(function () {
    'use strict';

    angular
        .module('searchV2Module')
        .config(['searchV2ServiceProvider', function (searchV2ServiceProvider) {

            searchV2ServiceProvider.setStateParamsConfig({
                sourceType: { value: undefined }
            });

            searchV2ServiceProvider.stateParamsToSourceQueryParamsTransformers.push(function (stateParams, searchSource) {
                if (stateParams.withHighlighting !== false) {
                    searchSource.queryParams.withHighlighting = true;
                }
            });

            searchV2ServiceProvider.searchResultToContextTransformers.push(function (searchCtxt, stateParams) {
                searchCtxt.sources = _.map(searchCtxt.sources, function (ctxtSource) {
                    if (_.isEmpty(ctxtSource.searchResponse)) return ctxtSource;

                    ctxtSource.isSelected = ctxtSource.sourceType === stateParams.sourceType;
                    ctxtSource._GOV = ctxtSource.searchResponse._GOV;

                    // Map items with highlighting
                    if (_.has(ctxtSource.searchResponse, 'highlighting')) {
                        ctxtSource.results = _.map(ctxtSource.results, function (result) {
                            var uniqueItemId = result[ctxtSource.uniqueItemIdKey];

                            result.highlighting = ctxtSource.searchResponse.highlighting[uniqueItemId];

                            return result;
                        });
                    }

                    return ctxtSource;
                });

            });
        }])
        .directive('searchSourceSelector', directive);

    directive.$inject = [];

    function directive() {
        return {
            restrict: 'AE',
            scope: {
                searchCtxt: '=',
                version: '=?',
                onSourceChanged: '&'
            },
            template: '<div ng-include="getTemplateUrl()"></div>',
            controller: ['$rootScope', '$scope', 'searchV2Service', function ($rootScope, $scope, searchV2Service) {

                $scope.getTemplateUrl = function () {
                    if (_.isUndefined($scope.version)) $scope.version = 'default';

                    return '/app/shared/searchV2/searchSourceSelector-' + $scope.version + '.tpl.html';
                };

                $scope.toggleSourceSelection = function (searchSource) {

                    var sourceType = searchSource.sourceType;
                    if (searchSource.isSelected) sourceType = undefined;

                    searchV2Service
                        .search({
                            sourceType: sourceType,
                            sf:null

                        }).then(function (searchCtxt) {
                            $scope.searchCtxt = searchCtxt;

                            if ($scope.onSourceChanged)  $scope.onSourceChanged();
                        });
                };

            }]
        };
    }

})();